import { NextPage } from 'next';
import React from 'react';
import { useIntl } from 'react-intl';

import HeadMeta from '@/components/static-pages/HeadMeta';
import CampgroundDirectoryTemplate, {
  IProps,
} from '@/components/templates/CampgroundDirectoryTemplate';
import getPageData from '@/services/getPageData.js';

const CampgroundDirectory: NextPage<IProps> = props => {
  const intl = useIntl();

  const { title, seo_description, locality, canonical_url } = props.metadata;

  const localityTitle = locality && locality.title;

  const pageTitle = localityTitle
    ? intl.formatMessage(
        {
          defaultMessage:
            'Discover the top RV Parks &amp; Campgrounds in {locality} so you can plan the best trip',
          id: 'xORLSi',
        },
        { locality: localityTitle },
      )
    : title;

  const pageSEODescription = localityTitle
    ? intl.formatMessage(
        {
          defaultMessage:
            'Looking for the best camping spots in {locality}? Discover and book the best {locality} area campgrounds for tent camping, RV camping, cabins, glamping and more, with millions of photos and reviews from campers like you.',
          id: 'LqgQbO',
        },
        { locality: localityTitle },
      )
    : seo_description;

  return (
    <>
      <HeadMeta
        title={pageTitle}
        description={pageSEODescription}
        canonicalUrl={canonical_url}
        noindex={!!props.fallback}
      />
      <CampgroundDirectoryTemplate {...props} />
    </>
  );
};

CampgroundDirectory.getInitialProps = async ({ req, res, query }) => {
  const pageData = await getPageData({ req, res, query });

  return { ...pageData };
};

export default CampgroundDirectory;
